import { render, staticRenderFns } from "./chat-v2.vue?vue&type=template&id=2e2c5d80&scoped=true&"
var script = {}
import style0 from "./chat-v2.vue?vue&type=style&index=0&id=2e2c5d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c5d80",
  null
  
)

export default component.exports